export const isCarseerAvilableinthisCountry = (countryCode: string) => {
  return Boolean(
    process.env.NEXT_PUBLIC_CARSEER_COUNTRY_CODES?.split("|")?.includes(
      countryCode
    )
  );
};

export const isMojazAvilableinthisCountry = (countryCode: string) => {
    return Boolean(
        process.env.NEXT_PUBLIC_MOJAZ_COUNTRY_CODES?.split("|")?.includes(
            countryCode
        )
    );
}

